export const INSERT_DISABLED_MESSAGE =
  'You cannot have more than 3 items on one row.';
